import {
  FETCH_BOOTH_LISTING_FAILURE,
  FETCH_BOOTH_LISTING_SUCCESS
} from "./boothTypes";
import {
  setLoaderRequestTrue,
  setLoaderRequestFalse,
} from "../common/commonAction";
import { GetApiActionWithAuthorization } from "../../constantFunctions/apiActions";

/*_________________________________________________________________Booth Listing __________________________________________________________________ */

//Api Call Function for user listing
export const fetchBoothListing = (params) => {
  return (dispatch) => {
    dispatch(setLoaderRequestTrue());
    dispatch(fetchBoothListingSuccess([]));
    GetApiActionWithAuthorization("common/get-all-booths", params)
      .then((res) => {
        dispatch(setLoaderRequestFalse());
        dispatch(fetchBoothListingSuccess(res.data));
      })
      .catch((err) => {
        dispatch(setLoaderRequestFalse());
        dispatch(fetchBoothListingFailure(err));
      });
  };
};

//Boothlisting Success save Payload data to store
export const fetchBoothListingSuccess = (data) => {
  return {
    type: FETCH_BOOTH_LISTING_SUCCESS,
    payload: data,
  };
};

//Boothlisting Failure save Payload
export const fetchBoothListingFailure = (error) => {
  return {
    type: FETCH_BOOTH_LISTING_FAILURE,
    payload: error,
  };
};
/*__________________________________________________________________________________________________________________________________________ */
